export default "__VITE_ASSET__4e673785__"